import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const CoreActions = createActionGroup({
    source: 'System Core',
    events: {
        'Set Redirect URL': props<{ redirectUrl: string }>(),
        'Login Redirect URL': emptyProps,
        'Reset Redirect URL': emptyProps
    }
});